import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import UsermenuComponent from '@/components/Usermenu'
import commonMixin from '@/mixin/common'
import {userinfo, getUser} from '@/api/server/user'
export default {
  name: 'UserInfoPage',
  mixins: [commonMixin],
  data () {
    return {
        name: null,
        gender: '0',
        phone: null,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    'user-menu': UsermenuComponent
  },
  computed: {
  },
  methods: {
    onSubmit () {
        if (!this.name) {
            this.error('请正确填写姓名')
            return false
        }
        if (!this.isPhone(this.phone)) {
            this.error('请正确填写手机号码')
            return false
        }
        let gender = this.gender
        let ret = ['0','1','2'].find( (item) => {
            return item === gender
        })
        if (!ret) {
            this.error('请正确选择性别')
            return false
        }
        let query = {
            name: this.name,
            phone: this.phone,
            gender: this.gender
        }
        userinfo(query).then( (res) => {
            if (res.code === 200) {
                this.success('修改成功')
            } else {
                this.warning(res.message, 'bottom')
            }
        })
    },
    _getUser () {
        getUser().then( (res) => {
            console.log('res', res)
            if (res.code === 200) {
                this.phone = res.data.phone
                this.name = res.data.name
                this.gender = String(res.data.gender)
            } else {
                this.warning(res.message, 'bottom')
            }
        })
    },
    reset () {
      this.phone = null
      this.name = null
      this.gender = '0'
      this._getUser()
    },
    handleRoute (route) {
      if (route.name === 'user') {
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}